export default function getResource(label) {
    const resources = {
        viewMore: 'Voir plus',
        viewLess: 'Voir moins'
    };
    return resources[label];
}
